export default __webpack_public_path__ + "static/media/SELMA.c0bdfb85.png";